import { render } from "./FashionTile.vue?vue&type=template&id=0fa3ec86&scoped=true&ts=true"
import script from "./FashionTile.vue?vue&type=script&lang=ts"
export * from "./FashionTile.vue?vue&type=script&lang=ts"

import "./FashionTile.vue?vue&type=style&index=0&id=0fa3ec86&scoped=true&lang=scss"
import "./FashionTile.vue?vue&type=style&index=1&id=0fa3ec86&lang=scss"
import "./FashionTile.vue?vue&type=style&index=2&id=0fa3ec86&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fa3ec86"]])

export default __exports__